export default {
    ONTOLOGICAL_MODEL: "Схема отологическая модели",
    ONTOLOGICAL_MODEL_DOWNLOAD_FAILED: (error) => `Не удалось сохранить схему отологической модели${error ? `: ${error}` : ""}`,
    ONTOLOGICAL_MODEL_DOWNLOAD_SUCCESS: "Онтологическая модель сохранена в загрузках",
    SAVED_SUCCESSFULLY: "Онтологическая модель успешно обновлена",
    SAVED_FAILED: "Не удалось сохранить онтологическую модель",
    UPLOAD_FAILED: "Не удалось импортировать онтологическую модель",
    UPLOAD_SUCCESS: "Онтологическая модель успешно импортирована",
    RELOAD__SUCCESS: "Онтологическая модель успешно обновлена",
    RELOAD__FAILED: "Не удалось обновить онтологическая модель",
    EXPORT__SUCCESS: "Онтологическая модель выгружена успешно",
    EXPORT__FAILED: "Не удалось выгрузить онтологическая модель"
};
